import React, { useState, useEffect } from "react";
import {
  Center,
  Image,
  Text,
  Box,
  useMediaQuery,
} from "@chakra-ui/react";
import FGameImg from "../../assets/Game2AbajoIzq.png";
import SGameImg from "../../assets/Game2ArribaDer.png";
import Boy from "../../assets/kidsAvatar/Boy.png";
import Girl from "../../assets/kidsAvatar/Girl.png";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "../../lib/axios";
import { useDispatch } from 'react-redux'
import { selectKid } from '../../reducers/kidReducer'

const KidSelector = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [kids, setKids] = useState([]);

  useEffect(() => {
    if (!user) return;
    axios
      .get(`/User/get-family?email=${user.email}`)
      .then((response) => {
        const kidsList = response.data.data.hijos;
        kidsList.forEach((kid) => {
          if (kid.sexoId === 1) {
            kid.fotoHijo = Boy;
          } else {
            kid.fotoHijo = Girl;
          }
        });
        setKids(kidsList);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [user, setKids]);

  const handleChildrenSelect = (kid) => {
    dispatch(selectKid(kid));
    navigate("/Home");
  };
  const [isSmallScreen] = useMediaQuery("[max-width: 768px]");

  return (
    <Center minHeight="100vh" flexDirection="column" p={5}>
      <Text as="h1" fontSize="3xl" mb={5} fontWeight="bold">
        Select the child's profile
      </Text>

      <Box
        display={isSmallScreen ? "flex-direction:column" : "flex"}
        flexWrap="wrap"
        justifyContent="center"
      >
        {kids.length > 0 ? (
          kids.map((kid) => (
            <Box
              key={kid.hijoId}
              p={4}
              mx={4}
              borderWidth="0px"
              borderRadius="lg"
              transition="transform 0.2s ease-in-out"
              _hover={{ transform: "scale(1.1)" }}
              onClick={() => handleChildrenSelect(kid)}
              cursor="pointer"
            >
              <Image src={kid.fotoHijo} alt={kid.hijoId} width="15rem" />
              <Text mt={2} textAlign="center">
                {kid.nombre} {kid.apellido}
              </Text>
            </Box>
          ))
        ) : (
          <div>Loading...</div>
        )}
      </Box>

      {/* Fondo de imagen 1 (abajo a la derecha) */}
      <Image
        src={FGameImg}
        alt="Primera imagen"
        style={{
          position: "fixed",
          bottom: "0",
          right: "0",
          zIndex: "-1",
        }}
      />

      {/* Fondo de imagen 2 (arriba a la izquierda) */}
      <Image
        src={SGameImg}
        alt="Segunda imagen"
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          zIndex: "-1",
        }}
      />
    </Center>
  );
};

export default KidSelector;
